import { render, staticRenderFns } from "./TemplateManagerModal.vue?vue&type=template&id=9b3bf0fa&scoped=true"
import script from "./TemplateManagerModal.vue?vue&type=script&lang=js"
export * from "./TemplateManagerModal.vue?vue&type=script&lang=js"
import style0 from "./redacteur-ui.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TemplateManagerModal.vue?vue&type=style&index=1&id=9b3bf0fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3bf0fa",
  null
  
)

export default component.exports